module.exports = __webpack_public_path__ + "fd8b4a0bfc34776b432b5da61386c17c.svg";